export const logoSliderInit = (slider, nextEl = null, prevEl = null) => {
    if (!slider) {
        return
    }

    const args = {
        loop: false,
        spaceBetween: 20,
        slidesPerView: 6,
        initialSlide: 0,
        breakpoints: {
            0: {
                slidesPerView: 3.66,
                spaceBetween: 12,
            },
            800: {
                slidesPerView: 6,
                spaceBetween: 12,
            },
            1023: {
                spaceBetween: 20,
            },
        },
        // Добавляем navigation только если nextEl и prevEl переданы
        ...(nextEl && prevEl
            ? {
                navigation: {
                    nextEl,
                    prevEl,
                },
            }
            : {}),
    }

    // eslint-disable-next-line no-undef
    return new Swiper(slider, args)
}
